/**
 * Tucks the sticky header away while the reader scrolls down and brings it
 * back the moment they scroll up, so long pages give the full viewport to
 * content without costing anyone a trip to the top to reach the nav.
 */
(function () {
  'use strict';

  var header = document.querySelector('.shopify-section--header');
  if (!header) return;

  // Nothing to hide if the header scrolls away on its own.
  if (window.getComputedStyle(header).position !== 'sticky') return;

  var HIDDEN = 'nr-header--hidden';

  // Leave the header alone near the top: at that point it is about to scroll
  // out of view anyway, and hiding it reads as a flicker.
  var HIDE_BELOW = 140;

  // Trackpads and rubber-band scrolling emit a lot of sub-pixel noise; ignore
  // anything smaller than a deliberate gesture.
  var THRESHOLD = 6;

  var last = window.pageYOffset;
  var ticking = false;

  function overlayOpen() {
    // This theme toggles drawers with aria-hidden rather than a class. Sliding
    // the header out from under an open drawer, the search panel or the
    // quickshop is disorienting, and the search panel is anchored to it.
    return !!document.querySelector(
      '.Drawer[aria-hidden="false"], .Search[aria-hidden="false"], ' +
      '.Modal[aria-hidden="false"], .nr-qs:not([hidden])'
    );
  }

  function show() { header.classList.remove(HIDDEN); }

  function update() {
    ticking = false;

    var y = window.pageYOffset;
    if (y < 0) return; // iOS overscroll

    // Keyboard users tabbing through the nav must be able to see where they are.
    if (overlayOpen() || header.contains(document.activeElement)) {
      show();
      last = y;
      return;
    }

    var delta = y - last;
    if (Math.abs(delta) < THRESHOLD) return;

    if (delta > 0 && y > HIDE_BELOW) {
      header.classList.add(HIDDEN);
    } else if (delta < 0) {
      show();
    }

    last = y;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });

  // Anchor jumps and in-page links can land mid-document with the header
  // tucked away; reveal it so the nav is never stranded offscreen.
  window.addEventListener('hashchange', show);
  document.addEventListener('focusin', function (event) {
    if (header.contains(event.target)) show();
  });
})();
